import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import './Splash.css';
import SvgIcon from '../components/SvgIcon';
import IconButton from '../components/IconButton';
import colors from '../colors';

class Splash extends Component {
  render() {
    let style = this._getDefaultStyles();
    let navIconStyle = { 
      width: 64,
      height: 64,
      fill: colors.white
    };
    let logoStyle = {
      width: 256,
      height: 256,
      marginTop: -32,
      marginBottom: -72
    };

    return (
      <div className="splash page" style={style}>
        <div className="content flex-center-items">
          <div>
            <SvgIcon icon="df-logo" style={logoStyle} />
          </div>
          <div className="heading">
            <h1>De-Formance</h1>
          </div>
          <div className="heading">
            <h2>we return to the body for knowledge</h2>
          </div>
          <div className="splash-picture flex-fill"></div>
          <div className="navRight flex-column flex-justify-items">
            <IconButton icon="chevron-right" iconStyle={navIconStyle}
                        onClick={this._handleNavNext}  />
          </div>
        </div>
      </div>
    );
  }
  
  _getDefaultStyles() {
    let defaultStyle = {
      backgroundColor: colors.darkBeige,
      color: colors.white
    };

    return defaultStyle;
  }

  _handleNavNext() {
    browserHistory.push('/setup');
  }
}

export default Splash;



/** WEBPACK FOOTER **
 ** ./src/containers/Splash.js
 **/